import { Route, Routes } from "react-router-dom";
import GearDetailPage from "./GearDetailPage";
import GearListPage from "./GearListPage";

const GearsRoutes = () => {
  return (
    <Routes>
      <Route index element={<GearListPage />} />
      <Route path=":id" element={<GearDetailPage />} />
    </Routes>
  );
};

export default GearsRoutes;
